import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import FeatureIcon from '../../components/FeatureIcon';
import { MaintenanceWindow, formatDateTime } from './statusData';

interface MaintenanceNoticeProps {
  windows: MaintenanceWindow[];
}

const STATUS_LABELS: Record<string, string> = {
  scheduled: 'Scheduled maintenance',
  in_progress: 'Maintenance in progress',
};

// One containing notice for upcoming/active windows only; completed and
// cancelled records are fetched but not presented here.
const MaintenanceNotice: React.FC<MaintenanceNoticeProps> = ({ windows }) => {
  const { colors, dsColors } = useTheme();
  const active = windows.filter(
    (w) => w.status === 'scheduled' || w.status === 'in_progress'
  );
  if (active.length === 0) return null;

  return (
    <section aria-labelledby="status-maintenance-heading" className="status-maintenance">
      <h2
        id="status-maintenance-heading"
        className="status-panel-heading"
        style={{ color: colors.textPrimary }}
      >
        <FeatureIcon name="wrench" size={20} className="status-panel-icon" />
        Scheduled maintenance
      </h2>
      <div className="status-maintenance-notice" style={{ borderColor: dsColors.signalBlue }}>
        {active.map((window) => (
          <div key={window.id} className="status-maintenance-item">
            <div className="flex flex-wrap items-baseline gap-x-3 mb-1">
              <h3 className="font-semibold" style={{ color: colors.textPrimary }}>
                {window.title}
              </h3>
              <span className="status-maintenance-label" style={{ color: dsColors.signalBlue }}>
                {STATUS_LABELS[window.status] ?? window.status}
              </span>
            </div>
            {window.description && (
              <p className="text-sm mb-2" style={{ color: colors.textSecondary }}>
                {window.description}
              </p>
            )}
            <dl className="status-maintenance-times" style={{ color: colors.textSecondary }}>
              <div>
                <dt className="inline font-medium">Start: </dt>
                <dd className="inline"><time dateTime={window.start_time}>{formatDateTime(window.start_time)}</time></dd>
              </div>
              <div>
                <dt className="inline font-medium">End: </dt>
                <dd className="inline"><time dateTime={window.end_time}>{formatDateTime(window.end_time)}</time></dd>
              </div>
              {window.affected_services.length > 0 && (
                <div>
                  <dt className="inline font-medium">Affected: </dt>
                  <dd className="inline">{window.affected_services.join(', ')}</dd>
                </div>
              )}
            </dl>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MaintenanceNotice;
